import { Mail } from "lucide-react";

import { Hint } from "@/components/ui/hint";

import { SUPPORT_MAILTO_URL } from "@/lib/support";
import { analytics } from "@/lib/analytics/analytics-service";
import { cn } from "@/lib/utils";

interface ContactSupportNavItemProps {
  collapsed: boolean;
}

export function ContactSupportNavItem({
  collapsed,
}: ContactSupportNavItemProps): JSX.Element {
  const handleClick = (): void => {
    analytics.track("support_link_clicked");
  };

  const link = (
    <a
      href={SUPPORT_MAILTO_URL}
      onClick={handleClick}
      className={cn(
        "text-muted-foreground hover:bg-muted/50 dark:hover:bg-muted/30 hover:text-foreground border border-transparent group flex items-center w-full py-3 lg:py-2 mb-0.5 text-base lg:text-sm rounded-md transition-all",
        collapsed ? "justify-center px-0" : "px-4 lg:px-3",
      )}
    >
      <Mail
        className={cn(
          "h-6 w-6 lg:h-5 lg:w-5 flex-shrink-0",
          !collapsed && "mr-4 lg:mr-3",
        )}
      />
      {!collapsed && "Contact Support"}
    </a>
  );

  return collapsed ? (
    <Hint
      text="Contact Support"
      side="right"
      align="center"
      delayDuration={100}
    >
      {link}
    </Hint>
  ) : (
    link
  );
}
